import { X } from "lucide-react";
import React from "react";

const CloseButton = ({ closeBtnPos, actionFunction }) => {
  return (
    <button
      className={`py-[0.5rem] px-[1rem] outline-none border-none bg-[red] text-white text-lg rounded-md cursor-pointer absolute top-[5%] ${closeBtnPos === "left" ? "left-[5%]" : "right-[5%]"} hover:opacity-80`}
      type="button"
      onClick={actionFunction}
      title="Click to close"
    >
      <X />
    </button>
  );
};

export default CloseButton;
